import { message, Upload } from "antd";
import { requestUploads } from "./api";
import { ImageValidationError, validateImage } from "./imageValidation";

export type UploadKind = "brick" | "thumbnail";

export const ACCEPTED_IMAGE_TYPES = "image/png,image/jpeg,image/webp";

export const uploadImage = async (
  organization: string,
  collection: string,
  kind: UploadKind,
  file: File,
  onProgress?: (percent: number) => void
): Promise<string> => {
  const contentType = await validateImage(file);
  const [upload] = await requestUploads(organization, collection, [{ kind, contentType }]);

  const form = new FormData();
  Object.entries(upload.fields as Record<string, string>).forEach(
    ([name, value]) => form.append(name, value)
  );
  form.append("file", file);

  await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", upload.url);
    xhr.upload.onprogress = (ev) => onProgress?.((ev.loaded / ev.total) * 100);
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300
        ? resolve()
        : reject(new Error(xhr.responseText || `Upload failed (${xhr.status})`));
    xhr.onerror = () => reject(new Error("Upload failed"));
    xhr.send(form);
  });

  return upload.key;
};

// For antd Upload's beforeUpload: rejected files never enter the upload list.
export const rejectInvalidImage = async (file: File) => {
  try {
    await validateImage(file);
    return true;
  } catch (e) {
    if (!(e instanceof ImageValidationError)) throw e;
    message.error(`${file.name}: ${e.message}`);
    return Upload.LIST_IGNORE;
  }
};
